import {useAppSelector} from '@/hooks';

export function useShowContextualSkeletons(): boolean {
  const isPosterObject = useAppSelector((state) => {
    return state.posterEditor.posterObject !== undefined;
  });
  const currentPageId = useAppSelector((state) => {
    return state.posterEditor.currentPageId;
  });
  const isCurrentPageObject = window.posterEditor?.whiteboard?.pages.pagesHashMap[currentPageId] !== undefined;

  const showSkeleton = (): boolean => {
    return !isPosterObject || !isCurrentPageObject;
  };

  return showSkeleton();
}
